import { render, staticRenderFns } from "./XlsExport.vue?vue&type=template&id=4e4c7afd&scoped=true&"
import script from "./XlsExport.vue?vue&type=script&lang=js&"
export * from "./XlsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c7afd",
  null
  
)

export default component.exports